document.addEventListener('click', function (event) {
  const toggle = event.target.closest('[data-menu-toggle]');
  if (!toggle) return;
  const nav = document.querySelector('[data-mobile-nav]');
  if (nav) nav.hidden = !nav.hidden;
});

document.querySelectorAll('[data-slideshow]').forEach(function (slideshow) {
  const slides = slideshow.querySelectorAll('[data-slide]');
  const buttons = slideshow.querySelectorAll('[data-slide-button]');
  buttons.forEach(function (button) {
    button.addEventListener('click', function () {
      const index = button.getAttribute('data-slide-button');
      slides.forEach(function (slide) { slide.classList.toggle('is-active', slide.getAttribute('data-slide') === index); });
      buttons.forEach(function (item) { item.classList.toggle('is-active', item === button); });
    });
  });
});
